module.exports = __webpack_public_path__ + "img/semi-supervised.91b04819.png";